import { useState } from "react";
import "./Arts.css";

import Gallery from "./components/Gallery";
import ArtistPortfolio from "./components/ArtistPortfolio";
import ArtChallenges from "./components/ArtChallenges";

import artworks from "./data/artworks";
import artists from "./data/artists";
import challenges from "./data/challenges";

export default function Arts() {
  const [openArtwork, setOpenArtwork] = useState(null);
  const [activeComponent, setActiveComponent] = useState("gallery");

  return (
    <div>
      <div className="button-container">
        <button onClick={() => setActiveComponent("gallery")} className="button-tab">Gallerie</button>
        <button onClick={() => setActiveComponent("portfolio")} className="button-tab">PortFolio</button>
        <button onClick={() => setActiveComponent("challenges")} className="button-tab">Challenges</button>
      </div>
      
      {activeComponent === "gallery" && <Gallery artworks={artworks} setOpenArtwork={setOpenArtwork} />}
      {activeComponent === "portfolio" && <ArtistPortfolio artists={artists} />}
      {activeComponent === "challenges" && <ArtChallenges challenges={challenges} />}
      
      {openArtwork && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-4 rounded">
            <h2>{openArtwork.title}</h2>
            <p>Par {openArtwork.artist}</p>
            <img src={openArtwork.image} alt={openArtwork.title} className="w-full rounded" />
            <button onClick={() => setOpenArtwork(null)} className="mt-2 bg-red-500 text-white px-4 py-2 rounded">Fermer</button>
          </div>
        </div>
      )}
    </div>
  );
}
